import React, { useEffect } from "react";
import { useFormik } from "formik";
import { useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import MenuItem from "@mui/material/MenuItem";

import FromikTextField from "../../Components/Utils/Formik_Texfiled";
import AlternativeHeader from "../../Components/Headres/Alternative_Header";
import CustomButton from "../../Components/Utils/Custom_Btn";

import { useAdminValidation } from "../../Components/Validation/use_AdminValidation";
import { useToast } from "../../Hooks/useToast";
import { FetchCreateAdmin } from "../../Apis/Auth/Create_Admin";
import { fetchGetAdminById } from "./../../Redux/Admin_Slice";
import { UpdateAdmin } from "../../Apis/Auth/Get_Admins";

const CreateAdmin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const data = useSelector((item) => item.Admin);
  const isEditing = Boolean(params.id);
  const { formValidation } = useAdminValidation();
  const { toastSuccess, toastError } = useToast();

  useEffect(() => {
    if (params.id) {
      dispatch(fetchGetAdminById(params.id));
    }
  }, [params.id]);

  const formik = useFormik({
    initialValues: {
      adminName: "",
      email: "",
      password: "",
      passwordConfirm: "",
      role: "manager",
    },
    validationSchema: formValidation(isEditing),
    onSubmit: async (values, { setSubmitting, setFieldError }) => {
      if (params.id) {
        const updatedValues = { ...values };
        if (!values.password) delete updatedValues.password;
        if (!values.passwordConfirm) delete updatedValues.passwordConfirm;
    
        const result = await UpdateAdmin(params.id, updatedValues);
        if (result?.status === 200) {
          toastSuccess("Admin wurde erfolgreich aktualisiert!");
          navigate("/AdminVerwaltung");
        } else {
          toastError("Admin-Aktualisierung fehlgeschlagen!");
          setFieldError("email", "Aktualisierung fehlgeschlagen! Bitte erneut versuchen.");
        }
    
        setSubmitting(false);
      } else {
        try {
          const result = await FetchCreateAdmin(values);
          if (result?.status === 201) {
            toastSuccess("Admin wurde erfolgreich erstellt!");
            navigate("/AdminVerwaltung");
          } else {
            toastError("Admin-Erstellung fehlgeschlagen!");
            setFieldError("email", "Erstellung fehlgeschlagen! Bitte erneut versuchen.");
          }
        } catch (error) {
          toastError("Fehler bei der Admin-Erstellung aufgetreten!");
        } finally {
          setSubmitting(false);
        }
      }
    }
  });

  useEffect(() => {
    if (params.id && data.data.data) {
      formik.setValues(data.data.data);
    }
  }, [data.data.data]);

  return (
    <Box ml={2}>
      <AlternativeHeader
        onPrevious={() => navigate("/AdminVerwaltung")}
        title="Neuen Admin hinzufügen"
      />

      <Box mt={6}>
        <Grid container spacing={4}>
          <Grid size={5}>
            <FromikTextField
              formik={formik}
              name="adminName"
              label="Name"
              placeholder="Admin Name"
              required
            />
          </Grid>

          <Grid size={5}>
            <FromikTextField
              formik={formik}
              name="email"
              label="E-Mail"
              placeholder="Email Address"
              required
            />
          </Grid>

          {!params.id && (
            <>
              <Grid size={5}>
                <FromikTextField
                  formik={formik}
                  name="password"
                  label="Passwort"
                  type="password"
                  placeholder="Password"
                  required
                />
              </Grid>

              <Grid size={5}>
                <FromikTextField
                  formik={formik}
                  name="passwordConfirm"
                  label="Passwort wiederholen"
                  type="password"
                  placeholder="Confirm Password"
                  required
                />
              </Grid>
            </>
          )}

          <Grid size={5}>
            <FromikTextField
              formik={formik}
              name="role"
              label="Role"
              select
              placeholder="Select Role"
              required
            >
              <MenuItem value="manager">manager</MenuItem>
              <MenuItem value="admin">admin</MenuItem>
            </FromikTextField>
          </Grid>
        </Grid>
      </Box>

      <Divider sx={{ mt: 4, bgcolor: "#000000" }} />

      <Box mt={2} display="flex" justifyContent="end">
        <CustomButton
          type="submit"
          title="speichern"
          onNavigate={formik.handleSubmit}
        />
      </Box>
    </Box>
  );
};

export default CreateAdmin;
